import React from 'react';
import { Mountain, Users, Calendar, CheckCircle } from 'lucide-react';
import { useLanguage } from '@/contexts/LanguageContext';
import { motion } from 'framer-motion';

const StatsSection: React.FC = () => {
  const { t } = useLanguage();

  const stats = [
    { icon: Mountain, value: '200+', label: t('home.stats.projects') },
    { icon: Calendar, value: '15+', label: t('home.stats.years') },
    { icon: Users, value: '150+', label: t('home.stats.clients') },
    { icon: CheckCircle, value: '500+', label: t('home.stats.inspections') },
  ];

  return (
    <section className="py-16 md:py-20 bg-secondary">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-12">
          {stats.map((stat, index) => (
            <motion.div
              key={index}
              className="text-center group"
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-50px" }}
              transition={{ duration: 0.5, delay: index * 0.15, ease: "easeOut" }}
            >
              <div className="inline-flex items-center justify-center w-14 h-14 rounded-2xl bg-primary/15 mb-4 group-hover:bg-primary/25 transition-colors">
                <stat.icon className="h-7 w-7 text-primary" />
              </div>
              <p className="text-3xl md:text-4xl font-bold text-white mb-1">
                {stat.value}
              </p>
              <p className="text-sm md:text-base text-white/70">
                {stat.label}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default StatsSection;
